/* GODS & KINGS — make THE RITUAL unmistakably three simple steps; remove redundant unnumbered subtitle. */
(function(){
  function install(root){
    var scope=root||document;
    var section=scope.querySelector('#ritual')||document.querySelector('#ritual')||scope.querySelector('#system')||document.querySelector('#system');
    if(!section)return;
    section.querySelectorAll('.gk-section-subtitle').forEach(function(el){el.remove();});
    if(section.querySelector('.gk-ritual-steps'))return;
    var title=section.querySelector('.gk-section-title');
    if(!title)return;
    var steps=document.createElement('div');
    steps.className='gk-ritual-steps';
    steps.setAttribute('aria-label','The Ritual — three steps');
    steps.innerHTML='<span><b>01</b> CLEANSE</span><i aria-hidden="true">→</i><span><b>02</b> RECODE</span><i aria-hidden="true">→</i><span><b>03</b> DEFEND</span>';
    title.insertAdjacentElement('afterend',steps);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){install(document)});else install(document);
  document.addEventListener('shopify:section:load',function(e){install(e.target)});
})();